import { useState } from "react"
import { ChangeEvent } from "react"

function useFormStateHandler<T>(initialState: T) {
   const [formState, setFormState] = useState<T>(initialState)

   const handleChange = (
      e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
   ) => {
      const { name, value } = e.target
      setFormState((prev) => ({
         ...prev,
         [name]: value,
      }))
   }

   const setField = (field: keyof T, value: unknown) => {
      setFormState((prev) => ({
         ...prev,
         [field]: value,
      }))
   }

   return [formState, setFormState, handleChange, setField] as const
}

export default useFormStateHandler
